import React from "react";

const logoUrl = process.env.PUBLIC_URL
  ? `${process.env.PUBLIC_URL}/logojes.png`
  : "/logojes.png";

/**
 * Écran de chargement global (auth, traductions, etc.) : même identité que
 * le reste du site (fond `ink-field`, grain, marque ember, typo Fraunces)
 * plutôt qu'une palette slate/amber générique et une photo de fond.
 */
const AppLoadingScreen = ({ message = "Chargement...", subMessage }) => {
  return (
    <div className="min-h-screen ink-field relative flex flex-col items-center justify-center p-4 overflow-hidden">
      <div className="grain-overlay" aria-hidden />

      <div className="relative z-10 flex flex-col items-center gap-9">
        {/* Marque */}
        <div className="flex flex-col items-center gap-4">
          <div className="h-14 w-14 sm:h-16 sm:w-16 rounded-2xl bg-gradient-to-br from-ember-400 to-ember-600 p-0.5 shadow-lg shadow-ember-900/25 animate-pulse">
            <div className="h-full w-full rounded-[15px] bg-ink-900/85 flex items-center justify-center">
              <img
                src={logoUrl}
                alt="JesCook"
                className="h-8 sm:h-9 w-auto object-contain"
              />
            </div>
          </div>
          <div className="text-center">
            <p className="font-display text-xl sm:text-2xl font-semibold text-white tracking-tight">
              JesCook
            </p>
            <p className="text-ember-200/85 text-[11px] uppercase tracking-[0.14em] font-semibold mt-1">
              Menus du monde
            </p>
          </div>
        </div>

        {/* Spinner + message */}
        <div className="flex flex-col items-center gap-4">
          <div
            className="w-9 h-9 sm:w-10 sm:h-10 rounded-full border-2 border-white/15 border-t-ember-500 animate-spin"
            aria-hidden
          />
          <div className="text-center">
            <p className="text-white/90 font-medium text-sm sm:text-base">
              {message}
            </p>
            {subMessage && (
              <p className="text-white/50 text-xs sm:text-sm mt-1">
                {subMessage}
              </p>
            )}
          </div>
        </div>

        {/* Barre de progression */}
        <div className="w-full max-w-[180px] h-1 bg-white/10 rounded-full overflow-hidden">
          <div
            className="h-full w-1/3 bg-gradient-to-r from-ember-600 to-ember-400 rounded-full"
            style={{
              animation: "appLoadingBar 1.5s ease-in-out infinite",
            }}
          />
        </div>
      </div>

      <style>{`@keyframes appLoadingBar { 0%, 100% { transform: translateX(-100%); } 50% { transform: translateX(250%); } }`}</style>
    </div>
  );
};

export default AppLoadingScreen;
